const scripts = {};
const scriptElements = {};
export default (url) => {
    if (!(url in scripts)) {
        const element = document.createElement('script');
        element.src = url;
        scripts[url] = new Promise((resolve, reject) => {
            element.onload = () => {
                scriptElements[url] = element;
                resolve();
            };
            element.onerror = reject;
            document.body.appendChild(element);
        });
    }
    return scripts[url];
};
export function unloadScript(url) {
    const element = scriptElements[url];
    if (element) {
        delete scriptElements[url];
        delete scripts[url];
        console.debug('Removing script element for', url);
        document.body.removeChild(element);
    }
}
